import React, { memo, useEffect, useRef, useState } from "react";
import styles from "./style.module.css";
import { useSelector, useDispatch } from "react-redux";
import {
  addCardStore,
  addCompare,
  addCompares,
  addShopCartCount,
  removeCompares,
  setCompareProductAnimation,
  setShopCartProductAnimation,
} from "../../../../store/MainSlice";
import ShopCartSvg from "../../../../assets/SVG/ShopCartSvg";
import CompareSvg from "../../../../assets/SVG/CompareSvg";
import { credit36Month } from "../../../../helpers/creditCalculator";
import UseOutSideClick from "../../../../helpers/UseOutSideClick";
import langData from "../../../../lang/data";
import UseCalcPrice from "../../../../helpers/UseCalcPrice";
import { Link } from "react-router-dom";
import checkBase64 from "helpers/checkBase64";
import { setOpenOrderModal } from "components/OrderModal/state/orderModalSlice";
import lang from "lang/lang";
import { SearchData } from "../../../../dataSearch";
import { HistorySearch, ClearHistory, ClearHistoryId } from "store/WsSearchSlice";
import { MyResultSvg } from "../ResultSvg";
import getImageUrl from "helpers/getImageUrl";
import axiosInstance from "store/request";


const getRandomItems = (data, count) => {
  const shuffled = [...data].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const getAllCategories = (data) => {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return [];
  const categories = data.categories;
  if (Array.isArray(categories) && categories.length > 0) return categories;
  const main = data.category;
  const similar = data.similar;
  if (main && Array.isArray(similar)) return [main, ...similar];
  if (main) return [main];
  if (Array.isArray(similar) && similar.length > 0) return similar;
  if (data.slug && (data.item === 'category' || !data.item)) return [data];
  if (data.search) return [{ slug: data.search, name: data.name_hy ?? data.name ?? data.search, id: data.search, parent_id: 1 }];
  if (data.redirect_url) {
    const m = data.redirect_url.match(/\/category\/(?:filter\/)?([^/?]+)/);
    if (m) return [{ slug: m[1], name: m[1], id: m[1] }];
  }
  return [];
};

const getCategoryIcon = (item) => {
  if (!item) return null;
  return item.icon ?? item.image?.image ?? item.category_image?.image ?? null;
};

const getStickerImage = (sticker, currentLanguage) => {
  if (!sticker) return null;
  const byLang =
    sticker?.[`image_${currentLanguage}`] ??
    sticker?.[`img_${currentLanguage}`] ??
    null;
  return (
    byLang ??
    sticker?.image_hy ??
    sticker?.image_ru ??
    sticker?.image_en ??
    sticker?.image ??
    null
  );
};
export default memo(function SearchModal({
  closeSearchModal,
  setCloseSearchModal,
  isFocused,
  searchText,
  setSearchText,
  isLoading,
  getSearchInfo,
  requestToken,
  setRequestToken,
  setIsFocused,
  onSearchChange,
  onKeyDown,
  setLoading,
  handleSearch,
  mobile
}) {
  const [active, setActive] = useState(0);
  const [noResult, setNoResult] = useState(false);
  const [mouseIn, setMouseIn] = useState(false);
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [previewImgIdx, setPreviewImgIdx] = useState(0);
  const [enrichedById, setEnrichedById] = useState({});
  const enrichInFlightRef = useRef(new Set());
  const { searchInfo, currentLanguage, currentCurrency, compares, WSsearchInfo } = useSelector(({ main }) => main);
  const displayData = searchInfo ?? (WSsearchInfo && typeof WSsearchInfo === 'object' && !Array.isArray(WSsearchInfo) ? WSsearchInfo : null);
  const { history } = useSelector(
    ({ WsSearchSlice }) => WsSearchSlice
  );
  const containerRef = useRef();
  const productImageRef = useRef();
  const dispatch = useDispatch();
  const [randomItems, setRandomItems] = useState(getRandomItems(SearchData?.[currentLanguage], 5));

  const showDesktopPreview = !mobile && window.innerWidth > 992;

  const resolveBrandForProduct = (p) => {
    return (
      p?.brand ??
      p?.product?.brand ??
      (Array.isArray(displayData?.brands)
        ? displayData.brands.find(
          (b) =>
            b?.id &&
            (b.id === p?.brand_id || b.id === p?.product?.brand_id)
        )
        : null) ??
      null
    );
  };

  const normalizeSearchProduct = (p) => {
    const toNum = (v) => {
      if (v == null) return 0;
      if (typeof v === "string") {
        const cleaned = v.replace(/\s+/g, "").replace(/,/g, ".");
        const n = Number(cleaned);
        return Number.isFinite(n) ? n : 0;
      }
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    };
    const id = p?.seller_product_id ?? p?.seller_id ?? p?.id ?? p?.product_id ?? null;
    const brandObj = resolveBrandForProduct(p);
    const sku = p?.li_product_id ?? p?.product?.li_product_id ?? null;

    const rawMedia = Array.isArray(p?.media)
      ? p.media
      : Array.isArray(p?.product?.media)
        ? p.product.media
        : [];
    const mediaPaths = rawMedia
      .map((m) => {
        if (!m) return null;
        if (typeof m === "string") return m;
        return (
          m?.images_source ??
          m?.thum_image_sourc ??
          m?.thum_image_source ??
          m?.image_source ??
          m?.image ??
          m?.url ??
          m?.path ??
          null
        );
      })
      .filter(Boolean);
    const primaryImg =
      p?.media?.[0]?.images_source ??
      p?.media?.[0]?.thum_image_sourc ??
      p?.media?.[0]?.thum_image_source ??
      p?.product?.thumbnail_image_source ??
      p?.thumbnail_image_source ??
      p?.thum_img ??
      null;
    const gallery = Array.from(
      new Set([primaryImg, ...mediaPaths].filter(Boolean).map(String))
    );
    const imagePath = gallery?.[0] ?? null;

    const pricing = p?.pricing ?? p?.product?.pricing ?? {};
    const isInstallingEnabled = !!getInstallingStatus(p);
    const installingPrice = toNum(
      pricing?.installing_price ??
      p?.installing_price ??
      p?.product?.installing_price
    );
    const applyInstalling = (price) => {
      const v = toNum(price);
      if (!v) return 0;
      return isInstallingEnabled ? v : Math.max(0, v - installingPrice);
    };

    const sellingBase = toNum(
      pricing?.selling_price ??
      p?.skus?.[0]?.selling_price ??
      p?.selling_price ??
      p?.min_sell_price ??
      0
    );

    const promoBase = toNum(
      pricing?.promo_price ??
      p?.promo_price ??
      p?.skus?.[0]?.promo_price ??
      p?.product?.promo_price ??
      0
    );

    const isOnline = !!(pricing?.is_online ?? p?.is_online ?? p?.product?.is_online);
    const onlinePriceFlag = toNum(pricing?.online_price ?? p?.online_price ?? p?.product?.online_price);
    const onlineSellingBase = toNum(
      pricing?.online_selling_price ?? p?.online_selling_price ?? p?.product?.online_selling_price
    );
    const hasOnline = isOnline && onlinePriceFlag > 0 && onlineSellingBase > 0;

    const selling = applyInstalling(sellingBase);
    const promo = promoBase > 0 ? applyInstalling(promoBase) : 0;
    const online = hasOnline ? applyInstalling(onlineSellingBase) : 0;
    const rawBestNew = promo > 0 ? promo : online > 0 ? online : 0;
    const bestNew = rawBestNew > 0 && selling > 0 && rawBestNew < selling ? rawBestNew : 0;
    const priceKind = bestNew > 0 ? (promo > 0 ? "promo" : "online") : "regular";

    const cashback = toNum(pricing?.cashback ?? p?.cashback ?? p?.product?.cashback ?? 0);
    const stickerRaw = p?.sticker ?? p?.product?.sticker ?? null;
    const sticker = Array.isArray(stickerRaw)
      ? stickerRaw
      : stickerRaw && typeof stickerRaw === "object"
        ? [stickerRaw]
        : [];

    const name = `${brandObj?.name ?? ""} ${p?.product_name ?? p?.product?.product_name ?? ""}`.trim();
    const base = {
      raw: p,
      id,
      brand: brandObj,
      sku,
      imagePath,
      gallery,
      sticker,
      name,
      selling: +selling || 0,
      promo: +bestNew || 0,
      priceKind,
      cashback: +cashback || 0,
    };
    const enriched = id != null ? enrichedById?.[id] : null;
    if (!enriched) return base;
    return {
      ...base,
      ...enriched,
      gallery: Array.isArray(enriched?.gallery) && enriched.gallery.length ? enriched.gallery : base.gallery,
      sticker: Array.isArray(enriched?.sticker) && enriched.sticker.length ? enriched.sticker : base.sticker,
      imagePath: enriched?.imagePath ?? base.imagePath,
      selling: enriched?.selling ?? base.selling,
      promo: enriched?.promo ?? base.promo,
      priceKind: enriched?.priceKind ?? base.priceKind,
      cashback: enriched?.cashback ?? base.cashback,
    };
  };

  const ensureEnriched = async (pid) => {
    if (!pid) return;
    if (enrichedById?.[pid]) return;
    if (enrichInFlightRef.current.has(pid)) return;
    enrichInFlightRef.current.add(pid);
    try {
      const auth = {
        token: process.env.REACT_APP_TOKEN,
        login: process.env.REACT_APP_LOGIN,
        password: process.env.REACT_APP_PASSWORD,
      };
      const res = await axiosInstance.post(`product-info/${pid}`, auth);
      const raw = res?.data;
      const product = raw?.product ?? raw?.data?.product ?? raw?.data ?? raw?.result ?? raw ?? {};

      const toNum = (v) => {
        if (v == null) return 0;
        if (typeof v === "string") {
          const cleaned = v.replace(/\s+/g, "").replace(/,/g, ".");
          const n = Number(cleaned);
          return Number.isFinite(n) ? n : 0;
        }
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
      };

      const selling = toNum(product?.selling_price ?? product?.min_sell_price ?? 0);
      const promo = toNum(product?.promo_price ?? 0);
      const isOnline = !!(product?.is_online ?? product?.product?.is_online);
      const onlineFlag = toNum(product?.online_price ?? product?.product?.online_price);
      const onlineSelling = toNum(product?.online_selling_price ?? product?.product?.online_selling_price);
      const online = isOnline && onlineFlag > 0 && onlineSelling > 0 ? onlineSelling : 0;
      const rawBestNew = promo > 0 ? promo : online > 0 ? online : 0;
      const bestNew = rawBestNew > 0 && selling > 0 && rawBestNew < selling ? rawBestNew : 0;
      const priceKind = bestNew > 0 ? (promo > 0 ? "promo" : "online") : "regular";

      const stickerRaw = product?.sticker ?? product?.product?.sticker ?? null;
      const sticker = Array.isArray(stickerRaw)
        ? stickerRaw
        : stickerRaw && typeof stickerRaw === "object"
          ? [stickerRaw]
          : [];

      const rawGallery = product?.gallary_images_api ?? product?.product?.gallary_images_api ?? [];
      const gallery = Array.isArray(rawGallery)
        ? rawGallery
          .map((g) => {
            if (!g) return null;
            if (typeof g === "string") return g;
            return g?.images_source ?? g?.thum_image_sourc ?? g?.thum_image_source ?? null;
          })
          .filter(Boolean)
        : [];

      const imagePath =
        gallery?.[0] ??
        product?.product?.thumbnail_image_source ??
        product?.thumbnail_image_source ??
        null;

      setEnrichedById((prev) => ({
        ...(prev || {}),
        [pid]: {
          imagePath,
          gallery,
          sticker,
          selling: selling || undefined,
          promo: bestNew || undefined,
          priceKind,
        },
      }));
    } catch (e) {
      // ignore
    } finally {
      enrichInFlightRef.current.delete(pid);
    }
  };

  useEffect(() => {
    if (!showDesktopPreview) return;
    if (!searchText?.length) {
      setHoveredProduct(null);
      return;
    }
    const first = displayData?.products?.[0];
    if (first) setHoveredProduct(normalizeSearchProduct(first));
    else setHoveredProduct(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDesktopPreview, searchText, displayData?.products?.length]);

  useEffect(() => {
    setPreviewImgIdx(0);
  }, [hoveredProduct?.id]);

  useEffect(() => {
    if (!hoveredProduct?.id) return;
    ensureEnriched(hoveredProduct.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hoveredProduct?.id]);

  useEffect(() => {
    if (!searchText?.length) return;
    if (!displayData?.products?.length) return;
    const t = setTimeout(() => {
      const first = normalizeSearchProduct(displayData.products[0]);
      if (first?.id) ensureEnriched(first.id);
    }, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, displayData?.products?.length]);



  const handleRefresh = () => {
    setRandomItems(getRandomItems(SearchData?.[currentLanguage], 5));
  };

  const handleClear = async () => {
    await dispatch(ClearHistory());
  }

  const handleClearId = async (id) => {
    await dispatch(ClearHistoryId(id));
  }
  UseOutSideClick(containerRef, () => setCloseSearchModal(true));

  // if (!closeSearchModal) {
  //   document.body.style.overflow = "hidden";
  // } else {
  //   document.body.style.overflow = "auto";
  // }

  useEffect(() => {
    const fetchData = async () => {
      if (isFocused) {
        try {
          await dispatch(HistorySearch());
        } catch (error) {
          console.error("Ошибка при загрузке истории:", error);
        }
      }
    };

    fetchData();
    handleRefresh()
  }, [isFocused, dispatch]);
  useEffect(() => {
    const modalBackground = document.getElementById("modal-background");
    if (!modalBackground) {
      return;
    }
    if (isFocused) {
      document.body.classList.add("no-scroll");
      modalBackground.style.display = "flex";
    } else {
      modalBackground.style.display = "none";
      document.body.classList.remove("no-scroll");
    }
  }, [isFocused, searchText, history]);
  // if (!Object.keys(searchInfo || {}).length || closeSearchModal) return null;
  function getInstallingStatus(product) {
    const productStatus = product?.installing_p;

    if (productStatus === 1) return 1;
    if (productStatus === 2) return 0;

    const brandStatus = product?.brand?.installing_b;

    if (brandStatus === 1) return 1;
    if (brandStatus === 2) return 0;

    const categoryStatus = product?.category?.installing;

    return categoryStatus === 1;
  }
  function getInstallationStatus(product) {
    const productStatus = product?.installation_p;

    if (productStatus === 1) return 1;
    if (productStatus === 2) return 0;

    const brandStatus = product?.brand?.installation_b;

    if (brandStatus === 1) return 1;
    if (brandStatus === 2) return 0;

    const categoryStatus = product?.category?.installation;

    return categoryStatus === 1;
  }
  return (
    <>
      {isFocused && (
        <div
          ref={containerRef}
          className={`${styles.container} ${showDesktopPreview ? styles.containerDesktop : ""}`}
          style={{
          boxShadow: mobile ? "unset" : ""
        }}>
          <div className={showDesktopPreview ? styles.mainDesktop : styles.main}>

            {(searchText?.length && !mobile) ? (
              <>
                {isLoading ? (
                  <div className={styles.searchedProduct} style={{ padding: '20px', color: 'var(--gray-muted)' }}>
                    {langData.header?.searchResult?.[currentLanguage] || 'Որոնել'}...
                  </div>
                ) : null}
                {!isLoading && displayData?.redirect_url ? (
                  <a
                    href={displayData.redirect_url}
                    className={styles.searchedProduct}
                    onClick={() => { setCloseSearchModal(true); setIsFocused(false); }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <div className={styles.searchedProdName}>
                      <span className={styles.name}>
                        {langData.header.searchResult?.[currentLanguage] || 'Որոնել'} «{searchText}»
                      </span>
                    </div>
                  </a>
                ) : null}
                {Object.keys(displayData?.brand || {}).length ? (
                  <Link
                    onClick={() => {
                      setCloseSearchModal(true);
                      setIsFocused(false);
                    }}
                    className={styles.searchedProduct}
                    to={`/brand/${displayData?.brand?.slug}/category`}
                  >
                    <div className={styles.searchedProdName}>
                      <img
                        className={styles.img}
                        src={
                          checkBase64(displayData?.brand?.logo)
                            ? "data:image/png;base64," + displayData?.brand?.logo
                            : process.env.REACT_APP_STORAGE_URL +
                            displayData?.brand?.logo
                        }
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = require("../../../../assets/defaultImg.png");
                        }}
                        alt={displayData?.brand?.name}
                      />
                      <span className={styles.name}>{displayData?.brand?.name}</span>
                    </div>
                  </Link>
                ) : null}

                {Array.isArray(displayData?.brands) && displayData.brands?.length
                  ? displayData.brands.slice(0, 6).map((b) => (
                    <Link
                      key={b?.id ?? b?.slug}
                      onClick={() => {
                        setCloseSearchModal(true);
                        setIsFocused(false);
                      }}
                      className={styles.searchedProduct}
                      to={`/brand/${b?.slug}/category`}
                    >
                      <div className={styles.searchedProdName}>
                        <img
                          className={styles.img}
                          src={getImageUrl(b?.logo) || require("../../../../assets/defaultImg.png")}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = require("../../../../assets/defaultImg.png");
                          }}
                          alt={b?.name}
                        />
                        <span className={styles.name}>{b?.name}</span>
                      </div>
                    </Link>
                  ))
                  : null}

                {getAllCategories(displayData).map((cat) => {
                  const slug = cat?.slug;
                  const iconSrc = getCategoryIcon(cat);
                  const name = cat?.["name_" + currentLanguage] || cat?.name;
                  if (!slug || !name) return null;
                  const to = !cat?.parent_id ? `/category/${slug}` : `/category/filter/${slug}`;
                  return (
                    <Link
                      key={cat?.id ?? slug}
                      className={styles.searchedProduct}
                      onClick={() => {
                        setCloseSearchModal(true);
                        setIsFocused(false);
                      }}
                      to={to}
                    >
                      <div className={styles.searchedProdName}>
                        <img
                          className={styles.img}
                          src={getImageUrl(iconSrc) || require("../../../../assets/defaultImg.png")}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = require("../../../../assets/defaultImg.png");
                          }}
                          alt={name}
                        />
                        <span className={styles.name}>{name}</span>
                      </div>
                    </Link>
                  );
                })}

                {Object.keys(displayData?.category || {}).length &&
                  Object.keys(displayData?.brand || {}).length ? (
                  <Link
                    onClick={() => {
                      setCloseSearchModal(true);
                      setIsFocused(false);
                    }}
                    className={styles.searchedProduct}
                    to={`/category/filter/${displayData?.category?.slug}?b=${displayData?.brand?.id}`}
                  >
                    <div className={styles.searchedProdName}>
                      <img
                        className={styles.img}
                        src={
                          checkBase64(displayData?.brand?.logo)
                            ? "data:image/png;base64," + displayData?.brand?.logo
                            : process.env.REACT_APP_STORAGE_URL +
                            displayData?.brand?.logo
                        }
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = require("../../../../assets/defaultImg.png");
                        }}
                        alt={displayData?.brand?.name}
                      />
                      <span className={styles.name}>
                        {displayData?.brand?.name},{" "}
                        {displayData?.category?.["name_" + currentLanguage]}
                      </span>
                    </div>
                  </Link>
                ) : null}
                {displayData?.products?.map((product, index) => {
                  const normalized = normalizeSearchProduct(product);
                  const pid = normalized.id;
                  if (!pid) return null;
                  return (
                    <Link
                      key={index}
                      onClick={() => {
                        setCloseSearchModal(true);
                        setIsFocused(false);
                      }}
                      onMouseEnter={() => showDesktopPreview && setHoveredProduct(normalized)}
                      className={styles.searchedProduct}
                      to={`${currentLanguage !== "hy" ? "/" + currentLanguage : ""
                        }/Product/${pid}`}
                    >
                      <div className={styles.searchedProdName}>
                        <img
                          className={styles.img}
                          src={getImageUrl(normalized.imagePath) || require("../../../../assets/defaultImg.png")}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = require("../../../../assets/defaultImg.png");
                          }}
                          alt={normalized.name}
                        />
                        <div className={styles.nameCodeProds}>
                          <span className={styles.name}>
                            {normalized.name}
                          </span>
                          {Array.isArray(normalized?.sticker) && normalized.sticker.length ? (
                            <div className={styles.inlineStickers}>
                              {normalized.sticker.slice(0, 2).map((s, idx) => {
                                const src = getStickerImage(s, currentLanguage);
                                if (!src) return null;
                                return (
                                  <img
                                    key={s?.id ?? `${normalized.id}-st-${idx}`}
                                    className={styles.inlineStickerImg}
                                    src={getImageUrl(src)}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null;
                                      currentTarget.style.display = "none";
                                    }}
                                    alt=""
                                  />
                                );
                              })}
                            </div>
                          ) : null}
                          {normalized.sku ? (
                            <span className={styles.codeOfProd}>
                              00{normalized.sku}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      {normalized.selling > 0 ? (
                        <div className={styles.searchedProdName}>
                          {!(normalized.promo > 0) ? (
                            <p className={styles.price}>
                              {UseCalcPrice(
                                normalized.selling,
                                currentCurrency
                              )}
                            </p>
                          ) : (
                            <div className={styles.promoPriceContainer}>
                              <p className={styles.newPrice}>
                                {UseCalcPrice(
                                  normalized.promo,
                                  currentCurrency
                                )}
                              </p>
                              <div className={styles.oldPriceContainer}>
                                <p className={styles.oldPrice}>
                                  {UseCalcPrice(
                                    normalized.selling,
                                    currentCurrency
                                  )}
                                </p>

                                <span className={styles.line} />
                              </div>
                            </div>
                          )}
                          {normalized.cashback > 0 ? (
                            <div className={styles.cashbackContainer}>
                              <span className={styles.cashbackText}>Cashback</span>
                              <span className={styles.cashbackPrice}>
                                {UseCalcPrice(
                                  normalized.cashback,
                                  currentCurrency
                                )}
                              </span>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </Link>
                  );
                })}
              </>
            ) : isFocused ? (
              <div className={styles.wsCont}>
                {mobile ? (
                  <div style={{ marginBottom: "30px" }}>
                    <input
                      placeholder={
                        langData.header.searchPlaceholder[currentLanguage]
                      }
                      className={`${styles.searchInput} ${(window.innerWidth <= 992 && isFocused) ? styles.wsFocusInput : ""}`}
                      onFocus={(e) => {
                        setIsFocused(true);
                        if (e.target.value.length) {
                          setCloseSearchModal(false);
                        }
                      }}
                      value={searchText}
                      onChange={onSearchChange}
                      onKeyDown={onKeyDown}
                    />
                    <span
                      className={styles.searchBtn}
                      onClick={() => {
                        if (searchText.length) {
                          setLoading(true);
                          handleSearch();
                        }
                      }}
                    >  {langData.buttons.search[currentLanguage]}
                    </span></div>
                ) : null}

                {!searchText?.length ? (
                  <>
                    <div className={`${styles.wsflex} ${styles.wsJusBetween} ${styles.wsAlignCenter}`}>
                      <div>{langData.header.recentSearches[currentLanguage]}</div>
                      <div className={`${styles.wsflex} ${styles.wsColorGray} ${styles.wsCursor} ${styles.wsAlignCenter}`} onClick={handleClear}>  {langData.header.cleanHistory[currentLanguage]} <span className={styles.wsImage}><img src="https://vlv.am/public/trash.png" /></span></div>
                    </div>
                    <hr className={styles.wsHr} />
                    <div className={styles.wsMb30}>
                      {history?.length > 0 ? (
                        history.map((item, index) => (
                          <button key={index} className={styles.wsButton} >
                            <span style={{color: "black"}} className={styles.wsCursor} onClick={async () => {
                              setSearchText(item.search_text);
                              await dispatch(getSearchInfo(item.search_text, requestToken, setRequestToken));
                            }}>{item.search_text}</span>
                            <img onClick={() => handleClearId(item.id)} className={`${styles.wsImageX} ${styles.wsCursor}`} src="https://vlv.am/public/close.png" />
                          </button>
                        ))
                      ) : <span className={styles.noHistory}>{langData.header.noHistory[currentLanguage]}</span>}

                    </div>
                    <div className={`${styles.wsflex} ${styles.wsJusBetween}`}>
                      <div>{langData.header.recommendedForYou[currentLanguage]}</div>
                      <div className={`${styles.wsflex} ${styles.wsColorGray} ${styles.wsCursor}`} onClick={handleRefresh} > {langData.header.refresh[currentLanguage]} <img className={styles.wsImage} src="https://vlv.am/public/refresh.png" /></div>
                    </div>
                    <hr className={styles.wsHr} />
                    <div>
                      <ul className={styles.wsUl}>
                        {randomItems.map((item, index) => (
                          <li className={`${styles.wsCursor}`} onClick={async () => {
                            setSearchText(item);
                            await dispatch(getSearchInfo(item, requestToken, setRequestToken));
                          }}><img className={styles.wsImage} src="https://vlv.am/public/search.png" /> {item}</li>
                        ))}
                      </ul>
                    </div>
                  </>
                ) :
                  <div style={{ overflow: "auto", height: "70vh" }}>
                    <span className={styles.wsMb30}> {langData.header.searchResult[currentLanguage]} </span>
                    {Object.keys(displayData?.brand || {}).length ? (
                      <Link
                        onClick={() => {
                          setCloseSearchModal(true);
                          setIsFocused(false);
                        }}
                        className={styles.searchedProduct}
                        to={`/brand/${displayData?.brand?.slug}/category`}
                      >
                        <div className={styles.searchedProdName}>
                          <img
                            className={styles.img}
                            src={
                              checkBase64(displayData?.brand?.logo)
                                ? "data:image/png;base64," + displayData?.brand?.logo
                                : process.env.REACT_APP_STORAGE_URL +
                                displayData?.brand?.logo
                            }
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = require("../../../../assets/defaultImg.png");
                            }}
                            alt={displayData?.brand?.name}
                          />
                          <span className={styles.name}>{displayData?.brand?.name}</span>
                        </div>
                      </Link>
                    ) : null}
                    {Array.isArray(displayData?.brands) && displayData.brands?.length
                      ? displayData.brands.slice(0, 6).map((b) => (
                        <Link
                          key={b?.id ?? b?.slug}
                          onClick={() => {
                            setCloseSearchModal(true);
                            setIsFocused(false);
                          }}
                          className={styles.searchedProduct}
                          to={`/brand/${b?.slug}/category`}
                        >
                          <div className={styles.searchedProdName}>
                            <img
                              className={styles.img}
                              src={
                                getImageUrl(b?.logo) ||
                                require("../../../../assets/defaultImg.png")
                              }
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = require("../../../../assets/defaultImg.png");
                              }}
                              alt={b?.name}
                            />
                            <span className={styles.name}>{b?.name}</span>
                          </div>
                        </Link>
                      ))
                      : null}
                    {getAllCategories(displayData).map((cat) => {
                      const slug = cat?.slug;
                      const iconSrc = getCategoryIcon(cat);
                      const name = cat?.["name_" + currentLanguage] || cat?.name;
                      if (!slug || !name) return null;
                      const to = !cat?.parent_id ? `/category/${slug}` : `/category/filter/${slug}`;
                      return (
                        <Link
                          key={cat?.id ?? slug}
                          className={styles.searchedProduct}
                          onClick={() => {
                            setCloseSearchModal(true);
                            setIsFocused(false);
                          }}
                          to={to}
                        >
                          <div className={styles.searchedProdName}>
                            <img
                              className={styles.img}
                              src={
                                getImageUrl(iconSrc) ||
                                require("../../../../assets/defaultImg.png")
                              }
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = require("../../../../assets/defaultImg.png");
                              }}
                              alt={name}
                            />
                            <span className={styles.name}>{name}</span>
                          </div>
                        </Link>
                      );
                    })}

                    {Object.keys(displayData?.category || {}).length &&
                      Object.keys(displayData?.brand || {}).length ? (
                      <Link
                        onClick={() => {
                          setCloseSearchModal(true);
                          setIsFocused(false);
                        }}
                        className={styles.searchedProduct}
                        to={`/category/filter/${displayData?.category?.slug}?b=${displayData?.brand?.id}`}
                      >
                        <div className={styles.searchedProdName}>
                          <img
                            className={styles.img}
                            src={
                              checkBase64(displayData?.brand?.logo)
                                ? "data:image/png;base64," + displayData?.brand?.logo
                                : process.env.REACT_APP_STORAGE_URL +
                                displayData?.brand?.logo
                            }
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = require("../../../../assets/defaultImg.png");
                            }}
                            alt={displayData?.brand?.name}
                          />
                          <span className={styles.name}>
                            {displayData?.brand?.name},{" "}
                            {displayData?.category?.["name_" + currentLanguage]}
                          </span>
                        </div>
                      </Link>
                    ) : null}
                    {displayData?.products?.map((product, index) => {
                      const normalized = normalizeSearchProduct(product);
                      const pid = normalized?.id;
                      if (!pid) return null;
                      const calculateFinalPrice = (price, product) => {
                        const isInstallingEnabled = getInstallingStatus(product);

                        const installingPrice = product?.pricing?.installing_price ?? 0;

                        return isInstallingEnabled ? price : price - installingPrice;
                      };
                      return (
                        <Link
                          key={index}
                          onClick={() => {
                            setCloseSearchModal(true);
                            setIsFocused(false);
                          }}
                          className={styles.searchedProduct}
                          to={`${currentLanguage !== "hy" ? "/" + currentLanguage : ""
                            }/Product/${pid}`}
                        >
                          <div className={styles.searchedProdName}>
                            <img
                              className={styles.img}
                              src={
                                getImageUrl(normalized?.imagePath) ||
                                require("../../../../assets/defaultImg.png")
                              }
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = require("../../../../assets/defaultImg.png");
                              }}
                              alt={normalized?.name}
                            />
                            <div className={styles.nameCodeProds}>
                              <span className={styles.name}>
                                {normalized?.name}
                              </span>
                              {Array.isArray(normalized?.sticker) && normalized.sticker.length ? (
                                <div className={styles.inlineStickers}>
                                  {normalized.sticker.slice(0, 2).map((s, idx) => {
                                    const src = getStickerImage(s, currentLanguage);
                                    if (!src) return null;
                                    return (
                                      <img
                                        key={s?.id ?? `${normalized.id}-st-m-${idx}`}
                                        className={styles.inlineStickerImg}
                                        src={getImageUrl(src)}
                                        onError={({ currentTarget }) => {
                                          currentTarget.onerror = null;
                                          currentTarget.style.display = "none";
                                        }}
                                        alt=""
                                      />
                                    );
                                  })}
                                </div>
                              ) : null}
                              {normalized?.sku ? (
                                <span className={styles.codeOfProd}>
                                  00{normalized?.sku}
                                </span>
                              ) : null}
                            </div>
                          </div>
                          {normalized?.selling > 0 ? (
                            <div className={styles.searchedProdName}>
                              {!(normalized?.promo > 0) ? (
                                <p className={styles.price}>
                                  {UseCalcPrice(
                                    normalized?.selling,
                                    currentCurrency
                                  )}
                                </p>
                              ) : (
                                <div className={styles.promoPriceContainer}>
                                  <p className={styles.newPrice}>
                                    {UseCalcPrice(
                                      normalized?.promo,
                                      currentCurrency
                                    )}
                                  </p>
                                  <div className={styles.oldPriceContainer}>
                                    <p className={styles.oldPrice}>
                                      {UseCalcPrice(
                                        normalized?.selling,
                                        currentCurrency
                                      )}
                                    </p>

                                    <span className={styles.line} />
                                  </div>
                                </div>
                              )}
                              {normalized?.cashback > 0 ? (
                                <div className={styles.cashbackContainer}>
                                  <span className={styles.cashbackText}>Cashback</span>
                                  <span className={styles.cashbackPrice}>
                                    {UseCalcPrice(
                                      normalized?.cashback,
                                      currentCurrency
                                    )}
                                  </span>
                                </div>
                              ) : null}
                            </div>
                          ) : null}
                          {window.innerWidth > 992 ? (
                            <div
                              className={styles.searchedProdHover}
                              onMouseMove={() => setMouseIn(true)}
                              onMouseOut={() => setMouseIn(false)}
                            >
                              <div className={styles.prodSlide}>
                                <img
                                  className={styles.brand}
                                  src={
                                    process.env.REACT_APP_STORAGE_URL + product?.brand?.logo
                                  }
                                  onError={({ currentTarget }) => {
                                    currentTarget.onerror = null;
                                    currentTarget.src = require("../../../../assets/defaultImg.png");
                                    currentTarget.style["max-width"] = "32px";
                                    currentTarget.style["max-height"] = "19px";
                                  }}
                                  alt={product?.brand?.name}
                                />
                                <div
                                  style={{
                                    width: "100%",
                                    height: "176px",
                                    position: "relative",
                                  }}
                                >
                                  <Link
                                    onClick={() => {
                                      setCloseSearchModal(true);
                                      setIsFocused(false);
                                    }}
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      bottom: 0,
                                      left: 0,
                                      right: 0,
                                      display: "flex",
                                      flexDirection: "row",
                                      marginBottom: "5px",
                                    }}
                                    ref={productImageRef}
                                    to={`${currentLanguage !== "hy" ? "/" + currentLanguage : ""
                                      }/Product/${pid}`}
                                  >
                                    {(product?.media?.length
                                      ? product?.media
                                      : Array.from({ length: 1 })
                                    ).map((_, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          cursor: "pointer",
                                          background: "transparent",
                                          width: "100%",
                                          height: "100%",
                                          marginRight: "5px",
                                          borderBottom:
                                            "1.5px solid " +
                                            (index === active
                                              ? "var(--red)"
                                              : "var(--gray-border)"),
                                          zIndex: 99,
                                          opacity: +mouseIn,
                                        }}
                                        onMouseMove={() => setActive(index)}
                                      />
                                    ))}
                                  </Link>
                                  {product?.media?.length ? (
                                    product?.media?.map((item, index) => (
                                      <div
                                        style={{
                                          zIndex: index,
                                          position: "absolute",
                                          top: 0,
                                          bottom: 0,
                                          right: 0,
                                          left: 0,
                                          paddingBottom: "5px",
                                        }}
                                        key={index}
                                      >
                                        <img
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                            opacity: active === index ? 1 : 0,
                                          }}
                                          alt={
                                            product?.brand?.name +
                                            " " +
                                            product?.product_name
                                          }
                                          src={
                                            process.env.REACT_APP_STORAGE_URL +
                                            item?.images_source
                                          }
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = require("../../../../assets/defaultImg.png");
                                          }}
                                        />
                                      </div>
                                    ))
                                  ) : (
                                    <div
                                      style={{
                                        zIndex: 1,
                                        position: "absolute",
                                        top: 0,
                                        bottom: 0,
                                        right: 0,
                                        left: 0,
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      <img
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "contain",
                                        }}
                                        alt={
                                          product?.brand?.name + " " + product?.product_name
                                        }
                                        src={
                                          process.env.REACT_APP_STORAGE_URL +
                                          product?.thumbnail_image_source
                                        }
                                        onError={({ currentTarget }) => {
                                          currentTarget.onerror = null;
                                          currentTarget.src = require("../../../../assets/defaultImg.png");
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div className={styles.descContainer}>
                                  <Link
                                    onClick={() => {
                                      setCloseSearchModal(true);
                                      setIsFocused(false);
                                    }}
                                    to={`${currentLanguage !== "hy" ? "/" + currentLanguage : ""
                                      }/Product/${pid}`}
                                  >
                                    {!(product?.pricing?.promo_price > 0) &&
                                      !(
                                        product?.pricing?.online_price > 0 &&
                                        product?.pricing?.is_online &&
                                        product?.pricing?.online_selling_price > 0
                                      ) ? (
                                      <p className={styles.price}>
                                        {UseCalcPrice(
                                          calculateFinalPrice(
                                            product?.pricing?.average_price > 0 ||
                                            product?.pricing?.selling_price
                                            , product),
                                          currentCurrency
                                        )}
                                      </p>
                                    ) : (
                                      <div className={styles.promoPriceContainer}>
                                        <p className={styles.newPrice}>
                                          {UseCalcPrice(
                                            calculateFinalPrice(
                                              +product?.pricing?.promo_price ||
                                              (product?.pricing?.online_price &&
                                                +product?.pricing?.online_selling_price)
                                              , product),
                                            currentCurrency
                                          )}
                                        </p>
                                        <div className={styles.oldPriceContainer}>
                                          <p className={styles.oldPrice}>
                                            {UseCalcPrice(

                                              +product?.pricing?.selling_price
                                              ,
                                              currentCurrency
                                            )}
                                          </p>

                                          <span className={styles.line} />
                                        </div>
                                      </div>
                                    )}
                                    {product?.pricing?.cashback > 0 ? (
                                      <div>
                                        <span className={styles.cashbackText}>
                                          Cashback
                                        </span>
                                        <span
                                          className={styles.cashbackPrice}
                                          style={{ marginLeft: "5px" }}
                                        >
                                          {UseCalcPrice(
                                            product?.pricing?.cashback,
                                            currentCurrency
                                          )}
                                        </span>
                                      </div>
                                    ) : null}
                                    <p className={styles.productName}>
                                      {product?.brand?.name + " " + product?.product_name}
                                    </p>

                                    {credit36Month(
                                      product?.pricing?.promo_price > 0 ||
                                      product?.pricing?.selling_price
                                    ) && (
                                        <div className={styles.priceMounth}>
                                          {UseCalcPrice(
                                            credit36Month(
                                              product?.pricing?.promo_price > 0 ||
                                              product?.pricing?.selling_price
                                            ),
                                            currentCurrency
                                          )}{" "}
                                          / {langData.month[currentLanguage]}
                                        </div>
                                      )}
                                  </Link>

                                  <div className={styles.btnsContainer}>
                                    {product?.li_product_id ? (
                                      <div
                                        className={styles.cardBtn}
                                        onClick={() => {
                                          if (
                                            product?.media?.[0] ||
                                            product?.thumbnail_image_source
                                          ) {
                                            const { top, left } =
                                              productImageRef.current?.getBoundingClientRect();

                                            dispatch(
                                              setShopCartProductAnimation({
                                                image:
                                                  product?.media?.[0]?.images_source ||
                                                  product?.thumbnail_image_source,
                                                position: {
                                                  top,
                                                  left,
                                                },
                                              })
                                            );
                                          }
                                          dispatch(
                                            addShopCartCount(
                                              +product?.pricing?.promo_price > 0 ||
                                              +(
                                                product?.pricing?.online_price > 0 &&
                                                product?.pricing?.is_online &&
                                                product?.pricing?.online_selling_price
                                              ) ||
                                              +product?.pricing?.selling_price
                                            )
                                          );
                                          dispatch(
                                            addCardStore({
                                              price:
                                                +product?.pricing?.promo_price > 0 ||
                                                +(
                                                  product?.online_price > 0 &&
                                                  product?.pricing?.is_online &&
                                                  product?.online_selling_price
                                                ) ||
                                                +product?.pricing?.selling_price,
                                              qty: 1,
                                              product_id: product?.seller_product_skus,
                                              seller_id: 1,
                                              shipping_method_id: 0,
                                              type: "product",
                                              is_buy_now: "no",
                                            })
                                          );
                                        }}
                                      >
                                        <ShopCartSvg className={styles.cardBtnSvg} />
                                        <span>
                                          {langData.buttons.add_to_cart[currentLanguage]}
                                        </span>
                                      </div>
                                    ) : (
                                      <button
                                        className={`${styles.cardBtn}`}
                                        onClick={() => {
                                          dispatch(
                                            setOpenOrderModal({
                                              open: true,
                                              id: product?.seller_id ?? product?.id,
                                            })
                                          );
                                        }}
                                      >
                                        {lang?.[currentLanguage].order}
                                      </button>
                                    )}
                                    <div
                                      onClick={() => {
                                        if (
                                          (product?.media?.[0] ||
                                            product?.thumbnail_image_source) &&
                                          !compares.length
                                        ) {
                                          const { top, left } =
                                            productImageRef.current?.getBoundingClientRect();
                                          dispatch(
                                            setCompareProductAnimation({
                                              image:
                                                product?.media?.[0]?.images_source ||
                                                product?.thumbnail_image_source,
                                              position: {
                                                top,
                                                left,
                                              },
                                            })
                                          );
                                        }
                                        if (!compares.length) {
                                          dispatch(
                                            addCompares(product.seller_product_skus)
                                          );
                                        } else {
                                          dispatch(
                                            removeCompares(product.seller_product_skus)
                                          );
                                        }

                                        dispatch(
                                          addCompare({
                                            product_sku_id: product?.id,
                                            data_type: product?.product_type,
                                          })
                                        );
                                      }}
                                      className={styles.compareBtn}
                                    >
                                      <CompareSvg active={compares.length} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </Link>
                      );
                    })}
                    {
                      (!Object.keys(displayData?.brand || {}).length && !isLoading &&
                        !getAllCategories(displayData).length &&
                        !displayData?.products?.length) ? (
                        displayData && Object.keys(displayData).length > 0 && handleSearch ? (
                          <div
                            className={styles.searchedProduct}
                            style={{ cursor: 'pointer', padding: '20px' }}
                            onClick={() => { setLoading?.(true); handleSearch(); }}
                          >
                            <span className={styles.name}>
                              {langData.header.searchResult?.[currentLanguage] || 'Որոնել'} «{searchText}»
                            </span>
                          </div>
                        ) : (
                          <div className={`${styles.wsflex} ${styles.wsAlignCenter} ${styles.wsJusCenter} ${styles.wsMT50}`}>
                            <MyResultSvg />
                          </div>
                        )
                      ) : null
                    }

                  </div>
                }
              </div>
            ) : null}
          </div>

          {showDesktopPreview && searchText?.length && !mobile ? (
            <div className={styles.previewPanel}>
              {!hoveredProduct?.id ? null : (
                <>
                  <div className={styles.previewMedia}>
                    <img
                      className={styles.previewImg}
                      src={
                        getImageUrl(
                          hoveredProduct?.gallery?.[previewImgIdx] ?? hoveredProduct?.imagePath
                        ) || require("../../../../assets/defaultImg.png")
                      }
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = require("../../../../assets/defaultImg.png");
                      }}
                      alt={hoveredProduct.name}
                    />
                    {Array.isArray(hoveredProduct?.gallery) && hoveredProduct.gallery.length > 1 ? (
                      <div className={styles.previewThumbs}>
                        {hoveredProduct.gallery.slice(0, 6).map((p, idx) => (
                          <button
                            key={`${p}-${idx}`}
                            type="button"
                            className={`${styles.previewThumbBtn} ${idx === previewImgIdx ? styles.previewThumbBtnActive : ""
                              }`}
                            onClick={() => setPreviewImgIdx(idx)}
                          >
                            <img
                              className={styles.previewThumbImg}
                              src={getImageUrl(p) || require("../../../../assets/defaultImg.png")}
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = require("../../../../assets/defaultImg.png");
                              }}
                              alt=""
                            />
                          </button>
                        ))}
                      </div>
                    ) : null}
                  </div>
                  <div className={styles.previewBrandRow}>
                    {hoveredProduct.brand?.logo ? (
                      <img
                        className={styles.previewBrandLogo}
                        src={getImageUrl(hoveredProduct.brand.logo) || require("../../../../assets/defaultImg.png")}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = require("../../../../assets/defaultImg.png");
                        }}
                        alt={hoveredProduct.brand?.name}
                      />
                    ) : null}
                    <div style={{ fontSize: 12, fontWeight: 700 }}>
                      {hoveredProduct.brand?.name || ""}
                    </div>
                  </div>
                  <div className={styles.previewName}>{hoveredProduct.name}</div>
                  {hoveredProduct.sku ? (
                    <div className={styles.previewSku}>SKU: 00{hoveredProduct.sku}</div>
                  ) : null}
                  {Array.isArray(hoveredProduct?.sticker) && hoveredProduct.sticker.length ? (
                    <div className={styles.previewStickers}>
                      {hoveredProduct.sticker.slice(0, 4).map((s, idx) => {
                        const img = getStickerImage(s, currentLanguage);
                        const label =
                          s?.["name_" + currentLanguage] ??
                          s?.name ??
                          s?.title ??
                          "";
                        const bg = s?.color ?? s?.bg_color ?? null;
                        if (img) {
                          return (
                            <img
                              key={s?.id ?? `${hoveredProduct?.id}-pst-${idx}`}
                              className={styles.previewStickerImg}
                              src={getImageUrl(img)}
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.style.display = "none";
                              }}
                              alt={label || ""}
                            />
                          );
                        }
                        if (!label) return null;
                        return (
                          <span
                            key={s?.id ?? `${label}-${idx}`}
                            className={styles.previewSticker}
                            style={bg ? { background: bg } : undefined}
                          >
                            {label}
                          </span>
                        );
                      })}
                    </div>
                  ) : null}
                  <div className={styles.previewPriceRow}>
                    {hoveredProduct.promo > 0 ? (
                      <div className={styles.promoPriceContainer}>
                        <p className={styles.newPrice}>
                          {UseCalcPrice(hoveredProduct.promo, currentCurrency)}
                        </p>
                        <div className={styles.oldPriceContainer}>
                          <p className={styles.oldPrice}>
                            {UseCalcPrice(hoveredProduct.selling, currentCurrency)}
                          </p>
                          <span className={styles.line} />
                        </div>
                      </div>
                    ) : (
                      <p className={styles.price}>
                        {UseCalcPrice(hoveredProduct.selling, currentCurrency)}
                      </p>
                    )}
                    {hoveredProduct?.priceKind === "online" ? (
                      <div className={styles.previewOnlineBadge}>
                        {currentLanguage === "hy"
                          ? "Առցանց գին"
                          : currentLanguage === "ru"
                            ? "Онлайн цена"
                            : "Online price"}
                      </div>
                    ) : null}
                    {hoveredProduct.cashback > 0 ? (
                      <div className={styles.cashbackContainer}>
                        <span className={styles.cashbackText}>Cashback</span>
                        <span className={styles.cashbackPrice}>
                          {UseCalcPrice(hoveredProduct.cashback, currentCurrency)}
                        </span>
                      </div>
                    ) : null}
                  </div>
                </>
              )}
            </div>
          ) : null}
        </div>
      )}
    </>
  );
});
